<template>
	<div class="order-list">
		<h3>Order Listing</h3>

		<div class="orderIdSearch">
			<div>
				<input name="orderIdSearch" placeholder="Order ID" v-model="orderId" v-on:keyup.enter="getOrders" autocomplete="off" />
			</div>

			<div>
				<b-datetimepicker v-model="fromDate" :datetime-formatter="dateFormatter" placeholder="From" icon="calendar-today" editable>
				</b-datetimepicker>
			</div>

			<div>
				<b-datetimepicker
					v-model="toDate"
					:datetime-formatter="dateFormatter"
					placeholder="To"
					icon="calendar-today"
					:min-datetime="minDate"
					editable
				>
				</b-datetimepicker>
			</div>

			<div @click="getOrders" class="search-button ">
				Search
			</div>

			<div class="deleteIcon">
				<span @click="clearSearch">
					<ios-close-icon w="40px" h="40px" />
				</span>
			</div>
		</div>

		<div class="total-amount" v-if="totalAmount">Total: {{ totalAmount.toLocaleString('en-GB') }}</div>

		<div class="orders">
			<div class="header"></div>
			<div class="order-item header">
				<div>Order ID</div>
				<div>Cashier</div>
				<div>Payment Method</div>
				<div>Created Time</div>
				<div>Total</div>
				<div>Status</div>
			</div>
		</div>

		<div v-for="(item, index) of orders" v-bind:key="index" class="orders">
			<div class="indexNumber">{{ getItemIndex(index) }}</div>
			<div>
				<div class="order-item">
					<div class="textWithPadding">{{ item.alias }}</div>
					<div class="textWithPadding">{{ item.cashier.name }}</div>
					<div>
						<div v-for="(paymentmethod, index) of item.payment_method" v-bind:key="index" class="payment-method">
							<div v-if="paymentmethod == 1" class="active cash">Cash</div>
							<div v-if="paymentmethod == 2" class="active card">Card</div>
							<div v-if="paymentmethod == 3" class="active points">Points</div>
							<div v-if="paymentmethod == 4" class="active coupon">Coupons</div>
						</div>
					</div>
					<div class="textWithPadding">{{ convertTime(item.createdAt) }}</div>
					<div class="price">{{ item.total_price.toLocaleString('en-GB') }}</div>
					<!-- <div>{{ orderStatus(item.pay_status) }}</div> -->
					<div @click="viewOrderDetail(item._id)" class="hyperlink">
						<div class="order-status-open order-status" v-if="item.pay_status == 0">
							<div>OPEN</div>
						</div>
						<div class="order-status-close order-status" v-if="item.pay_status == 1">
							<div>CLOSED</div>
						</div>
						<div class="order-status-expired order-status" v-if="item.pay_status == 2">
							<div>EXPIRED</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="pager">
			<paginate
				v-model="page"
				:page-count="pageCount"
				:click-handler="pagerClick"
				:prev-text="'prev'"
				:next-text="'next'"
				:container-class="'pagination'"
				v-if="displayPager"
			>
			</paginate>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'OrderList',
	components: {},
	data: function() {
		return {
			limit: this.$config.pageItemsLimit,
			// limit: 1,
			pageCount: 1,
			page: 1,
			orderId: null,
			displayPager: true,
			fromDate: null,
			toDate: null,
			minDate: null,
			orders: [],
			totalAmount: null
		}
	},

	mounted: async function() {
		this.getOrders()
	},

	watch: {
		fromDate: function(newFromDate) {
			if (newFromDate !== null && this.toDate == null) {
				this.toDate = new Date()
			} else if (newFromDate !== null) {
				this.minDate = newFromDate
			}
		}
	},

	methods: {
		// For calender format
		dateFormatter(dt) {
			// return dt.toLocaleDateString('en-GB')
			return this.$moment(dt).format('DD/MM/YY HH:mm')
		},

		// When user search by order ID
		clearSearch: async function() {
			this.orderId = null
			this.displayPager = true
			this.page = 1
			this.fromDate = null
			this.toDate = null
			this.totalAmount = null

			this.getOrders()
		},

		// Get orders by default
		getOrders: async function() {
			if (this.fromDate !== null && this.toDate == null) {
				this.$swal.fire({
					text: 'To Date is required...'
				})

				return
			}

			// Set requirecd data
			var data = {
				populate: ['salesperson', 'cashier'],
				limit: this.limit,
				sort: {
					createdAt: 'desc'
				}
			}

			if (this.orderId) {
				data.alias = this.orderId
			}

			if (this.fromDate) {
				data.time = {}
				data.time.createdAt = {
					$gte: this.$moment(this.fromDate).format('x')
				}

				data.time.createdAt.$lte = this.$moment(this.toDate).format('x')
				data.pay_status = 1
			}

			const apiGetOrders = await this.$api.orderList({ data })

			this.orders = apiGetOrders.data.list

			// Calculate page count for pager
			this.pageCount = apiGetOrders.data.total / this.limit
			const pageCount = apiGetOrders.data.total / this.limit

			// Get total amount
			if (this.fromDate && this.toDate) {
				this.getTotalAmount(pageCount)
			}

			if (!Number.isInteger(this.pageCount)) {
				this.pageCount = Math.ceil(this.pageCount)
			}
		},

		// Calculate total amount
		getTotalAmount: async function(pageCount) {
			this.totalAmount = 0
			const totalPages = Math.ceil(pageCount)

			this.orders.map(order => {
				this.totalAmount += order.total_price
			})

			if (totalPages > 1) {
				var i = 2

				while (i <= totalPages) {
					const skip = (i - 1) * this.limit

					var data = {
						skip,
						limit: this.limit,
						sort: {
							createdAt: 'desc'
						}
					}

					if (this.fromDate) {
						data.time = {}
						data.time.createdAt = {
							$gte: this.$moment(this.fromDate).format('x')
						}

						data.time.createdAt.$lte = this.$moment(this.toDate).format('x')
						data.pay_status = 1
					}

					const apiGetOrders = await this.$api.orderList({ data })

					if (apiGetOrders !== undefined) {
						apiGetOrders.data.list.map(order => {
							if (order.total_price) {
								this.totalAmount += order.total_price
							}
						})
					}

					i++
				}
			}
		},

		// Search by Order ID
		searchOrderId: async function() {
			var data = {
				populate: ['salesperson', 'cashier'],
				alias: this.orderId,
				limit: this.limit,
				sort: {
					createdAt: 'desc'
				}
			}

			if (this.fromDate) {
				data.time = {}
				data.time.createdAt = {
					$gte: this.$moment(this.fromDate).format('x')
				}

				data.time.createdAt.$lte = this.$moment(this.toDate).format('x')
				data.pay_status = 1
			}

			const apiSearchOrderId = await this.$api.orderList({ data })

			// Hide pager
			this.displayPager = false
			// Assign details
			this.orders = apiSearchOrderId.data.list
		},

		// When user click on pager
		pagerClick: async function(pageNumber) {
			if (this.fromDate !== null && this.toDate == null) {
				this.$swal.fire({
					text: 'To Date is required...'
				})

				return
			}

			// Calculate how many items to skip
			var skip
			if (pageNumber == 1) {
				skip = 0
			} else {
				skip = (pageNumber - 1) * this.limit
			}

			var data = {
				populate: ['salesperson', 'cashier'],
				limit: this.limit,
				skip,
				sort: {
					createdAt: 'desc'
				}
			}

			if (this.orderId) {
				data.alias = this.orderId
			}

			if (this.fromDate) {
				data.time = {}
				data.time.createdAt = {
					$gte: this.$moment(this.fromDate).format('x')
				}

				data.time.createdAt.$lte = this.$moment(this.toDate).format('x')
				data.pay_status = 1
			}

			const apiGetOrders = await this.$api.orderList({ data })

			this.orders = apiGetOrders.data.list
			this.page = pageNumber
		},

		// Convert time for receipt
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		},

		// When user clicked on view order
		viewOrderDetail: function(orderId) {
			// Save the order into x
			this.$store.dispatch('set_order_id', orderId)

			// Redirect to sales page
			this.$router.push('sales')
		},

		// Generate payment method for styling
		getItemIndex: function(index) {
			var indexNumber = index + 1
			var itemNumber

			if (this.page > 1) {
				itemNumber = (this.page - 1) * this.limit + indexNumber
			} else {
				itemNumber = indexNumber
			}

			if (itemNumber < 10) {
				return '0' + itemNumber
			} else {
				return itemNumber
			}
		}
	}
}
</script>

<style scoped>
@import '../styles/OrderList.css';
</style>
